import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export function Footer() {
  const { t } = useTranslation();

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring' as const,
        stiffness: 100,
        damping: 20,
      },
    },
  };

  return <motion.p
    variants={itemVariants}
    className="text-center text-xs text-zinc-400 mt-8"
  >
    {t('footer.copyright', { year: 2026 })}
  </motion.p>
}